import {
    KnowledgeAnswerModel,
    MpAnswerModel,
} from '../../model/knowledge.model'
let emptyFlagId = 0
// 文本
export const makeTextEmptyAnswer = (): KnowledgeAnswerModel => {
    emptyFlagId++
    return {
        k_answer: '',
        k_answer_type: 0,
        k_id: 0,
        ka_id: 0,
        flag_id: emptyFlagId,
    }
}
// 图片
export const makeImageEmptyAnswer = (): KnowledgeAnswerModel => {
    emptyFlagId++
    return {
        k_answer: '{}',
        k_answer_type: 1,
        k_id: 0,
        ka_id: 0,
        flag_id: emptyFlagId,
    }
}
export const makeFileEmptyAnswer = (): KnowledgeAnswerModel => {
    emptyFlagId++
    return {
        k_answer: '{}',
        k_answer_type: 4,
        k_id: 0,
        ka_id: 0,
        flag_id: emptyFlagId,
    }
}

// 卡片
export const makeCardEmptyAnswer = (): KnowledgeAnswerModel => {
    emptyFlagId++
    return {
        k_answer: '{}',
        k_answer_type: 5,
        k_id: 0,
        ka_id: 0,
        flag_id: emptyFlagId,
    }
}
// 小程序
export const makeMiniEmptyAnswer = (): KnowledgeAnswerModel => {
    emptyFlagId++
    const initObj: MpAnswerModel = {
        Mp_App_Id: '',
        username: '',
        title: '',
    }
    return {
        k_answer: `${JSON.stringify(initObj)}`,
        k_answer_type: 0,
        k_id: 0,
        ka_id: 0,
        flag_id: emptyFlagId,
    }
}

// 视频

export const makeVideoAnswer = (): KnowledgeAnswerModel => {
    return {
        k_answer: ``,
        k_answer_type: 6,
        k_id: 0,
        ka_id: 0,
        flag_id: emptyFlagId,
    }
}
